'use strict';

export function validateForm(id) {
    var tabletsInput = $("form#" + id + " input#calculatorRequest_Omega3InTablets");
    if (tabletsInput == undefined)
        return;
    if (tabletsInput.val() == 0 || tabletsInput.val() == undefined) {
        tabletsInput.val(500);
    }
}
